
import { Component, Vue } from 'vue-property-decorator'

import { Deal } from '@/types/Deal'
import dealModule from '@/store/deal'

import DealEditor from '@/components/company/deal/DealEditor.vue'
import ContentList from '@/components/listView/ContentList.vue'
import { ListType } from '@/utils/enums'

@Component({
  name: 'DealList',
  components: {
    DealEditor,
    ContentList
  }
})
class DealList extends Vue {
  public listType = ListType

  public get storeModule() {
    return dealModule
  }

  public get deals(): Deal[] {
    return dealModule.deals
  }

  public get headers() {
    return [
      { text: 'Name', value: 'name' },
      { text: 'Unternehmen', value: 'company.name' },
      { text: 'Typ', value: 'type' },
      { text: 'Startdatum', value: 'startDate' },
      { text: 'Enddatum', value: 'endDate' },
      { text: 'Einlösbar bis', value: 'validityDate' },
      { text: 'Status', value: 'status' },
      { text: 'Exklusiv', value: 'exclusive' }
    ]
  }

  public get filters(): string[] {
    return [
      'company.name',
      'type',
      'startDate',
      'endDate',
      'validityDate',
      'status'
    ]
  }

  public setDeal(deal: Deal): void {
    dealModule.setDeal(deal)
    this.$router.push({ name: 'DealDetail', params: { did: deal._id } })
  }
}

export default DealList
